/**
 * @file FileList.tsx
 * @author markJia(markjia@tencent.com)
 */
import { useUpload } from '@tencent/glue-react-upload';
import React, { useEffect } from 'react';
import { useUpdate } from '@tencent/glue-react-use';
export var FileList = function FileList(_ref) {
  var children = _ref.children;
  var update = useUpdate();
  var upload = useUpload();
  console.log('upload.fileItems: ', upload.fileItems);
  useEffect(function () {
    upload.addListener('file-items-change', update);
    return function () {
      return upload.addListener('file-items-change', useUpdate);
    };
  }, []);
  return React.createElement("div", null, upload.fileItems.map(function (item, idx) {
    return children(item.getInfo(), idx);
  }));
};